import React from 'react'

import { setDashboardTimespan } from '../utils'

export function useDashboardTimestamp(breadCrumbs: BreadCrumbState, dashboardContext: LiveDashboardContextValue): void {
    React.useEffect(() => {
        if (!breadCrumbs.selected && dashboardContext) {
            setDashboardTimespan(dashboardContext, 'last 24 hours')
        }
    }, [breadCrumbs]) // eslint-disable-line react-hooks/exhaustive-deps
}
